import { Dropdown, SplitButton } from "react-bootstrap";
import { Button } from "@emanprague/ppaskit";
import React from "react";
import type AdvancesPageViewModel from "viewModels/finance/advancesPageViewModel";
import type InvoicesPageViewModel from "viewModels/finance/invoicesPageViewModel";
import type PaymentsPageViewModel from "viewModels/finance/paymentsPageViewModel";

interface ExportButtonsProps {
  vm: AdvancesPageViewModel | PaymentsPageViewModel | InvoicesPageViewModel;
}

const ExportButtons: React.FC<ExportButtonsProps> = props => {
  const { vm } = props;
  const { translateGeneral: tg } = vm.localization;

  return (
    <>
      <Button aria-describedby={vm.navigationName} size="sm" onClick={() => vm.addToDownloadQueue("attachment")}>
        {`${tg("finance.button_download_attachments")} (${vm.selectedItems.size})`}
      </Button>
      <SplitButton
        id="download_button"
        menuAlign="right"
        title={`${tg("finance.button_download_list")} (${vm.selectedItems.size})`}
        size="sm"
        onClick={() => vm.addToDownloadQueue("list")}>
        <Dropdown.Item
          aria-describedby={vm.navigationName}
          key="download-xlsx"
          onClick={() => {
            void vm.addToDownloadQueue("list");
          }}>
          {tg("finance.button_download_list_default")}
        </Dropdown.Item>
        <Dropdown.Item
          aria-describedby={vm.navigationName}
          key="download-csv"
          onClick={() => {
            void vm.addToDownloadQueue("list-csv");
          }}>
          {tg("finance.button_download_list_alternative")}
        </Dropdown.Item>
      </SplitButton>
    </>
  );
};

export default ExportButtons;
